import { Field, FieldProps } from 'formik';
import { ErrorText } from '.';
import { userDetails } from '../../../../state/ducks/users/users';
import { styled } from '../../Theme/theme';
import UserDropDown from '../base/UserDropDown';

type Props = {
    name: string;
    placeHolder?: string;
    showSearch?: boolean;
    mode?: 'multiple' | 'tags';
    users?: Array<userDetails>;
    customUsers?: boolean;
    usersToExclude?: string[];
    currentUserId?: string;
};

const UserDropDownForm = ({ name, currentUserId, ...restProps }: Props) => {
    return (
        <Field name={name}>
            {({ field: { value }, meta, form: { setFieldValue, setFieldTouched } }: FieldProps) => {
                const { touched, error } = meta;
                const hasError = touched && error !== undefined;
                return (
                    <Container>
                        <UserDropDown
                            onChange={(value: any, option: any) => {
                                setFieldValue(name, value);
                            }}
                            onBlur={(value: any) => {
                                setFieldTouched(name);
                            }}
                            hasError={hasError}
                            value={value === '' || value === null ? undefined : value}
                            currentUserId={currentUserId}
                            {...restProps}
                        />
                        <ErrorText className="err-msg">{hasError && error}</ErrorText>
                    </Container>
                );
            }}
        </Field>
    );
};

interface ContainerProps {
    width?: string;
}
const Container = styled.div<ContainerProps>`
    width: ${(props) => props.width};
    .ant-select-multiple .ant-select-selection-item {
        border-radius: 100px !important;
        background-color: #cce8f4 !important;
        border: 1px solid #cce8f4 !important;
    }
    .ant-select-multiple .ant-select-selection-item-remove > .anticon {
        background-color: #fff !important;
        border-radius: 100px !important;

        svg {
            padding-top: 2px;
            width: 12px;
            height: 10px;
        }
    }
    .ant-select-dropdown {
        z-index: 10000 !important;
    }
    .ant-select-dropdown.ant-select-dropdown-placement-bottomLeft,
    .ant-select-dropdown.ant-select-dropdown-placement-bottomRight,
    .ant-select-dropdown.ant-select-dropdown-placement-topLeft,
    .ant-select-dropdown.ant-select-dropdown-placement-topRight {
        z-index: 10000 !important;
    }
`;

export default UserDropDownForm;
